import { NavBar } from 'components/NavBar/NavBar'
import { TabProvider } from 'components/Tabs/TabContext'
import { Tabs } from 'components/Tabs/Tabs'
import { Flex, MainHeadline, PageWrapper } from 'styling/GlobalStyles'
import { DashboardActions, PurchaseRequestActions } from './Actions'
import { DashboardHeader, PurchaseOrdersHeader, PurchaseRequestHeader } from './Header'
import {
  Approvals,
  Dashboard,
  PrePO,
  PurchaseOrders,
  PurchaseRequest,
  Receiving,
  WorkflowEditor,
} from './Tabs'

const tabs = [
  'Dashboard',
  'Purchase Requests',
  'Approvals',
  'SKU Resolution',
  'Purchase Orders',
  'Receiving',
  'Workflow Editor',
]
export const ProcurementDashboard = () => {
  const renderSection = (activeTab: string | null) => {
    switch (activeTab) {
      case 'Dashboard':
        return <Dashboard />
      case 'Purchase Requests':
        return <PurchaseRequest />
      case 'Approvals':
        return <Approvals />
      case 'SKU Resolution':
        return <PrePO />
      case 'Purchase Orders':
        return <PurchaseOrders />
      case 'Receiving':
        return <Receiving />

      case 'Workflow Editor':
        return <WorkflowEditor />
    }
  }

  const renderHeader = (activeTab: string | null) => {
    switch (activeTab) {
      case 'Dashboard':
        return <DashboardHeader />
      case 'Purchase Requests':
        return <PurchaseRequestHeader />
      case 'Purchase Orders':
        return <PurchaseOrdersHeader />
      default:
        return null
    }
  }

  const renderActions = (activeTab: string | null) => {
    switch (activeTab) {
      case 'Dashboard':
        return <DashboardActions />
      case 'Purchase Requests':
        return <PurchaseRequestActions />
      default:
        return null
    }
  }

  return (
    <>
      <NavBar />
      <PageWrapper noFooter>
        <TabProvider tabs={tabs} groupName='procurement-dashboard-tab'>
          {(activeTab) => (
            <>
              <Flex center between>
                <MainHeadline flex w='100%'>
                  Procurement
                </MainHeadline>
                <Flex gap='0.5rem'>{renderActions(activeTab)}</Flex>
              </Flex>
              <Flex height='24px'>{renderHeader(activeTab)}</Flex>
              <Flex mt='16' mb='16' gap='0.5rem '>
                <Tabs />
              </Flex>
              {renderSection(activeTab)}
            </>
          )}
        </TabProvider>
      </PageWrapper>
    </>
  )
}
